import { buildBindable } from '@monofe/di';
import type { ICacheStorage } from '../interface/cache';
import { bindCacheStorage, injectCacheStorage, unbindCacheStorage } from '../interface/cache';
import TYPES from '../interface/types';
import cacheStorage from './cache';

export default buildBindable<ICacheStorage>({
    id: TYPES.ICacheStorage,
    dependencies: [],
    bind: bindCacheStorage,
    remove: unbindCacheStorage,
    inject: injectCacheStorage,
    build: container => Promise.resolve(cacheStorage),
});
